<template>
  <footer class="bg-jade-900 text-white/60 text-center mt-10">
    <div class="container sm:divide-x sm:divide-white/50 sm:flex sm:items-center sm:justify-center py-4 space-y-6">
      <div class="flex flex-col items-center px-5">
        <img src="/img/logos/logo-white.svg" class="w-40" alt="True Market Insiders' logo">
        <div class="flex justify-center space-x-6">
          <a v-for="item in navigation.social" :key="item.name" :href="item.href" class="text-inherit hover:text-white/80" target="_blank">
            <span class="sr-only">{{ item.name }}</span>
            <i :class="`pi pi-${item.icon}`"></i>
          </a>
        </div>
      </div>
      <div class="sm:text-left px-5">
        <div class="text-white/80 uppercase font-bold mb-4">
          Contact Us
        </div>
        <div class="text-sm">
          <a href="tel:+18558220269" class="font-semibold text-inherit hover:text-white/80">(855) 822-0269</a> (U.S. & Canada)<br>
          <a href="tel:+15612061207" class="font-semibold text-inherit hover:text-white/80">+1 561-206-1207</a> (International)

          <div class="mt-2">
            <a href="mailto:support@truemarketinsiders.com" target="_blank" class="font-semibold text-inherit hover:text-white/80">support@truemarketinsiders.com</a></div>
        </div>
      </div>
    </div>
    <div class="bg-black py-4">
      <nav class="mb-4 sm:flex sm:justify-center sm:space-x-12" aria-label="Footer">
        <div v-for="item in navigation.legal" :key="item.name">
          <router-link :to="item.path" class="text-sm text-white/70 hover:text-white/90">{{ item.name }}</router-link>
        </div>
      </nav>
      <p class="text-xs mb-0">v{{ versionLabel }} © True Market Insiders 2016-{{ new Date().getFullYear() }}. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
import * as tmi from "@/constants";

import { useVersionInfo } from "@/composables/version-info";

export default {
  name: 'FooterBlock',
  setup() {
    const versionInfo = useVersionInfo();
    return { versionInfo };
  },
  computed: {
    navigation() {
      return {
        legal: [
          {
            name: tmi.PrivacyPolicyDisplayText,
            path: tmi.PrivacyPolicyPath,
          },
          {
            name: tmi.RefundPolicyDisplayText,
            path: tmi.RefundPolicyPath,
          },
          {
            name: tmi.SmsTextPolicyDisplayText,
            path: tmi.SmsTextPolicyPath,
          },
          {
            name: tmi.TermsOfUsePolicyDisplayText,
            path: tmi.TermsOfUsePolicyPath,
          },
          {
            name: tmi.WhitelistInstructionsDisplayText,
            path: tmi.WhitelistInstructionsPath,
          },
        ],
        social: [
          {
            name: 'Facebook',
            href: "https://www.facebook.com/chrisroweshow",
            icon: 'facebook',
          },
          {
            name: 'Twitter',
            href: "https://twitter.com/ChrisRoweShow",
            icon: 'twitter',
          },
          {
            name: 'Instagram',
            href: "https://www.instagram.com/chrisroweshow/",
            icon: 'instagram',
          },
          {
            name: 'Youtube',
            href: "https://www.youtube.com/@ChrisRoweShow",
            icon: 'youtube',
          },
        ]
      }
    },
    versionLabel() {
      return this.versionInfo.currentVersion;
    }
  }
}
</script>

